module.exports = "<pre> {{kioskInProgress | json}} </pre>\n\n<app-kiosk-edit [kiosk]=\"kiosk\" (kioskChanged)=\"kioskChanged($event)\"> </app-kiosk-edit>\n\n<button mat-raised-button (click)=\"saveKiosk()\" [disabled]=\"loading\" >Save </button>\n<app-loader [isLoading]=\"loading\" style=\"display:inline-block\"></app-loader>"


//////////////////
// WEBPACK FOOTER
// ./src/app/kiosk-edit-dialog/kiosk-edit-dialog.component.html
// module id = ./src/app/kiosk-edit-dialog/kiosk-edit-dialog.component.html
// module chunks = main